// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import * as analyticsService from "@store/Framework/Services/AnalyticsService";
import { getWebsite, getWebsiteName } from "@store/Framework/Store/Context/ContextSelectors";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";

export const useBunzlSettings = () => useSettingsCollection().bunzlSettings!;

export const useAnalytics = () => analyticsService;

export const useWebsite = () => {
    return useAppSelector(state => getWebsite(state));
};

export const useWebsiteName = () => {
    return useAppSelector(state => getWebsiteName(state));
};

/**
 * Settings Hooks
 */

export const useDisplayProductPricesPolicy = () => useBunzlSettings().displayProductPricesPolicy;

export const usePriceSortMaximum = () => useBunzlSettings().priceSortMaximum;
